import React from 'react';

const NotificationContentLine = ({ line, includeLineBreak }: { line: string, includeLineBreak: boolean }) => (
    <>
        <span>{line}</span>{includeLineBreak ? <br /> : <></>}
    </>
);
export const NotificationContent = ({ message }: {message: string}) => {
    const lines = message.split('\n');
    return (
        <div>
            {lines.map((line, i) => <NotificationContentLine key={line} line={line} includeLineBreak={i < lines.length - 1}/>)}
        </div>
    );
};
